module.exports = __webpack_public_path__ + "static/media/mp3.8e0500e1.png";